/**
 * The ONE place the Advanced AI Readiness Assessment price strings come from.
 * The assessment page falls back to these when the offer-status call has not
 * answered, and the pricing page's "coming soon" block renders them directly, so
 * the two pages cannot drift apart. (Whether finance's GST approval covers the
 * $99 launch price is an owner question, not something this file decides.)
 */
export const ADVANCED_ASSESSMENT_PRICE = {
  launchCad: 99,
  standardCad: 500,
  /** First-project credit that comes with the launch price. */
  creditCad: 99,
  creditValidDays: 90,
} as const;
